/**
 * @generated SignedSource<<1655f83cb53649f62da15c9e19bce2cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceTodoStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceTodoSchedulePublishMutation$variables = {
  id: string;
  scheduledArchiveAt?: string | null;
};
export type WorkspaceTodoSchedulePublishMutation$data = {
  readonly todoWorkspace: {
    readonly publish: {
      readonly status: WorkspaceTodoStatus;
    };
  };
};
export type WorkspaceTodoSchedulePublishMutation = {
  response: WorkspaceTodoSchedulePublishMutation$data;
  variables: WorkspaceTodoSchedulePublishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scheduledArchiveAt"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "scheduledArchiveAt",
    "variableName": "scheduledArchiveAt"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoSchedulePublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "publish",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoSchedulePublishMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "publish",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b4daa3b1e01581c5e7e6a1eb211884b0",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoSchedulePublishMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoSchedulePublishMutation(\n  $id: ID!\n  $scheduledArchiveAt: String\n) {\n  todoWorkspace(id: $id) {\n    publish(scheduledArchiveAt: $scheduledArchiveAt) {\n      status\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d802d564868cae873fc48b6096efd5cd";

export default node;
